
import { Navigate } from "react-router";
import { useEffect, type JSX } from "react";
import { useForm } from "react-hook-form"
import { FloatingInputBootStrap } from "../Common/FloatingInputBootstrap";
import { useAddBlocsMutation } from "../../stores/OkOkStore";
import type { ResponseError } from "../../types/CommonReponse";
import type { BlocsInsert } from "../../types/Blocs";
import TinyMceEditor from "../Common/TinyMceEditor";
import { useTrads } from "../../contexts/trads/useTrads";

export function  BlocsInsertForm (): JSX.Element {
    const  blocs:BlocsInsert={clef:"",texte:"",titre:""};
    const [addBlocs,result]=useAddBlocsMutation();
    const { register, handleSubmit,setError,control,setValue, formState: { errors } } = useForm({
        defaultValues:blocs,
        //shouldUseNativeValidation: true,
        mode:'onBlur',
    });
    const {translate}=useTrads();

    useEffect(()=>{
        if(result.error && 'data' in result.error) {
            const server_error:ResponseError=result.error as ResponseError;
            const errors =server_error.data.error;
            if(errors){
                for (const i in errors) {
                        // @ts-expect-error i est connu!
                        setError(i, {type:'validate',message: translate(errors[i])});  
                }
                result.reset();
            }
        }
    },[setError,result,translate]);
    
    return (
        result.isSuccess ? <Navigate to={`/blocs/${result.data.id.toString()}`} state={{"modified":true}}></Navigate>  :(
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        <form className="row" onSubmit={(event) => void handleSubmit(addBlocs)(event)}>
            <div className="col-12  mb-3">
                <FloatingInputBootStrap
                    name="clef"
                    label={translate('bloc_clef')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("clef", {
                        required: translate("bloc_error_clef_requis"),
                        minLength: 2
                    })} 
                />

            </div>
            <div className="col-12  mb-3">
                <FloatingInputBootStrap
                    name="titre"
                    label={translate('bloc_titre')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("titre" )} 
                />

            </div>
            <div className="col-12  mb-3">

                <p>{translate('bloc_texte')}</p>
                <TinyMceEditor 
                    control={control}
                    name="texte"
                    onChange={(data) => {setValue('texte',data,{shouldValidate:true});}}
                />
            </div>    
            <div className="col-4  mb-3">
                <button type="submit">{translate('form_submit')}</button>
            </div>
        </form>
        )
    )
};

export default BlocsInsertForm;

